module.exports = __webpack_public_path__ + "static/img/7areaB_04.5eb2250.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_04.png
// module id = 1216
// module chunks = 1